import { Component, OnInit } from '@angular/core';
import { S3Service } from '../services/s3.service';
import { Log } from '../models/prompt-log.interface';
import { CollectionsService } from '../services/collections.service'; // Import the CollectionsService
import { MatDialog } from '@angular/material/dialog';
import { DraftSectionDialogComponent } from '../draft-section-dialog/draft-section-dialog.component';
import { Collection } from '../models/collection.interface';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-prompt-log',
  templateUrl: './prompt-log.component.html',
  styleUrls: ['./prompt-log.component.scss']
})
export class PromptLogComponent implements OnInit {
  advisorLogs: Log[] = [];
  collections: Collection[] = []; // Array to store collections
  selectedCollection = 'Wildfire Mitigation'; // Default collection
  selectedCollectionId = ''; // Selected collection ID
  loading = true;

  constructor(
    private s3Service: S3Service,
    private collectionsService: CollectionsService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.collectionsService.getCollections().subscribe({
      next: data => {
        this.collections = data;
        const defaultCollection = this.collections.find(collection => collection.name === this.selectedCollection);
        if (defaultCollection) {
          this.selectedCollectionId = defaultCollection.collection_id;
          this.fetchLogs(this.selectedCollectionId);
        }
      },
      error: error => {
        console.error('There was an error while fetching the collections: ', error);
      }
    });
  }

  fetchLogs(collectionId: string) {
    this.loading = true;
    this.s3Service.getFiles('advisor', collectionId).subscribe({
      next: (data: Log[]) => {
        this.advisorLogs = data.filter(log => log.title);
      },
      error: error => {
        console.error('There was an error while fetching the logs: ', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  onCollectionChange(event: MatSelectChange) {
    this.selectedCollection = event.value;
    const selectedCollection = this.collections.find(collection => collection.name === this.selectedCollection);
    if (selectedCollection) {
      this.selectedCollectionId = selectedCollection.collection_id;
      this.fetchLogs(this.selectedCollectionId);
    }
  }

  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text).then(
      () => {
        console.log('Copying to clipboard was successful!');
      },
      err => {
        console.error('Could not copy text: ', err);
      }
    );
  }

  draftSection(log: Log): void {
    this.dialog.open(DraftSectionDialogComponent, {
      width: '1200px',
      height: 'auto',
      data: {
        context: log.response,
        filename: log.filename
      }
    });
  }

  getKeys(obj: object): string[] {
    return Object.keys(obj);
  }

  parseSummary(content: string): { summary: string; context: string } {
    const summaryMatch = content.match(/<summary>([\s\S]*?)<\/summary>/);
    const contextMatch = content.match(/<content>([\s\S]*?)<\/content>/);

    return {
      summary: summaryMatch ? summaryMatch[1].trim() : '',
      context: contextMatch ? contextMatch[1].trim() : ''
    };
  }
}
